import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { Box, Skeleton } from '@mui/material';
import { useMemo } from 'react';

import { Tabs } from 'app/shared-components/structure';
import { useNavigationHeader, useHeaderTitle } from 'app/hooks';
import useGetGroupServiceCategory from '../use-cases/GroupServiceCategoriesSettingsPage/hooks/useGetGroupServiceCategory';

const tabs = [
  {
    label: 'Settings',
    value: 'settings',
    path: '../settings',
  },
  {
    label: 'Content',
    value: 'content',
    path: '../content',
  },
];

export default function GroupServiceCategoryDetailsLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { categoryId } = useParams();
  const [searchParams] = useSearchParams();
  const organisationId = searchParams.get('organisationId');

  const { data: categoryData, isLoading: isCategoryLoading } = useGetGroupServiceCategory({
    categoryId,
    organisationId,
  });

  useNavigationHeader({
    title: 'Back to categories',
    navigateTo: `/service-templates/categories?organisationId=${organisationId}`,
  });

  const headerTitle = isCategoryLoading ? (
    <Skeleton variant="text" width={200} height={24} />
  ) : (
    categoryData?.name
  );

  useHeaderTitle(headerTitle);

  const selectedTab = useMemo(
    () => tabs.find((tab) => location.pathname.endsWith(tab.value))?.value ?? tabs[0].value,
    [location.pathname]
  );

  function handleTabChange(event, newValue) {
    const newPath = tabs.find((tab) => tab.value === newValue)?.path;
    const query = searchParams.toString();

    const navigateTo = query ? `${newPath}?${query}` : newPath;
    if (newPath) navigate(navigateTo, { relative: 'path', replace: true });
  }

  return (
    <Box className="grow flex flex-col px-20 py-16 gap-16 bg-white overflow-hidden">
      <Tabs tabs={tabs} selectedTab={selectedTab} handleChange={handleTabChange} />
      {children}
    </Box>
  );
}
